import './styles.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { ErrorBoundary } from 'react-error-boundary'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { ButtonComponent } from 'Components/UIComponents'
// https://codesandbox.io/s/nostalgic-browser-e9lpmf?file=/src/App.js:679-692

// ErrorFallback component to display when an error occurs
function ErrorFallback({ error, resetErrorBoundary }) {
  const history = useHistory()
  const { t } = useTranslation()

  if (error.message === 'unAuthorized') {
    setTimeout(() => {
      redirectToLogin()
    }, 5000)
  }

  const redirectToLogin = () => {
    localStorage.clear()

    history.push({
      pathname: ROUTE_STRINGS.login
    })
    resetErrorBoundary()
  }

  return (
    <>
      {error.message === 'unAuthorized' ? (
        <div className="session-expired-wrapper" data-testid="session-expired-wrapper">
          <div className="session-expired-container">
            <div className="info">
              <h3>{t('YOUR_SESSION_HAS_EXPIRED')}</h3>
              <p>{t('PLEASE_LOG_IN_AGAIN_TO_CONTINUE_USING_THE_APP')}</p>
            </div>
            <div className="session-expired-login-button">
              <ButtonComponent type="Custom" variant="action" label={t('RE_LOGIN')} onClick={redirectToLogin} />
            </div>
          </div>
        </div>
      ) : (
        <div className="error-boundary-container">
          <h2>{t('SOMETHING_WENT_WRONG')}</h2>
          <p>{error.status}</p>
          <p>{error.title}</p>
          <button onClick={resetErrorBoundary}>Try again</button>
        </div>
      )}
    </>
  )
}
// Wrapper component using ErrorBoundary
function MyErrorBoundary({ children }) {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
}
export default MyErrorBoundary
